export enum ApiRefreshTimerEnum {
  INSTANTLY = 0,
  MOUSE_CLICK = 300,
  KEYBOARD_INPUT = 700,
}
